<template>
    <div>
        <compWrapper
            :title="
                $t('product.promotion.menu', {
                    defaultValue: '活动信息',
                })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="type == 'query'"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-15 clearfix"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
            <div v-if="type != 'query'" class="text-right margin-right-15">
                <vButton theme="primary" @click="submit(0)">保存为草稿</vButton>
                <vButton
                    class="margin-left-10"
                    theme="success"
                    @click="submit(1)"
                    >保存并提交</vButton
                >
                <vButton class="margin-left-10" @click="cancel">{{
                    $t("global.common.operate_cancel", { defaultValue: "取消" })
                }}</vButton>
            </div>
        </compWrapper>
        <compWrapper
            v-if="type == 'query'"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
        >
            <compLog :data="logList"></compLog>
        </compWrapper>
        <!-- 添加全局的liading -->
        <vLoading size="large" transfer fix :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

import {
    HttpGetPromotionOne,
    HttpSavePromotion,
    HttpGetBudgetById,
    HttpSysOpLog,
} from "@/service/products/promotion";
import { HttpSellerSku } from "@/service/boss/allot";
export default {
    props: ["activeids", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        // compLog: () => import("./log"),
    },
    data() {
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            formData: {
                status: 0,
                accountFlag: "",
                lineName: "",
            },
            logList: [],
            loading: false,
        };
    },
    created() {
        this.update();
        if (this.type == "query") {
            this.getLog();
        }
    },
    computed: {
        ...mapGetters("diction", ["getNewProductList", "getNewAccountIdList"]),
        getBase() {
            let showquery = this.type == "query";
            return [
                {
                    label: "渠道",
                    key: "accountId",
                    tag: "vSelect",
                    query: showquery,
                    on: {
                        "on-change": (val) => {
                            this.changeChannel(val);
                            this.getBudget();
                        },
                    },
                    options: this.getNewAccountIdList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "国别:",
                    key: "countryCode",
                    query: true,
                },
                {
                    label: "Seller Sku",
                    key: "sellerSku",
                    on: {
                        "on-change": (val) => {
                            this.changeSellerSku(val);
                        },
                    },
                },
                {
                    label: "项目:",
                    key: "lineName",
                    query: true,
                },
                {
                    label: "项目ID",
                    key: "lineId",
                    show: false,
                },
                {
                    label: "ERP SKU:",
                    key: "erpSku",
                    query: true,
                },
                {
                    label: "活动名称",
                    key: "promotionName",
                },
                {
                    label: "推广渠道",
                    key: "promotionAccount",
                    props: {
                        readonly: false,
                        multiple: true,
                    },
                    tag: "vSelect",
                    options: [
                        {
                            value: "站外deal free",
                            label: "站外deal free",
                        },
                        {
                            value: "站外deal pay",
                            label: "站外deal pay",
                        },
                        {
                            value: "站外Facebook Giveaway",
                            label: "站外Facebook Giveaway",
                        },
                        {
                            value: "站外FB DEAL GROUP",
                            label: "站外FB DEAL GROUP",
                        },
                        {
                            value: "红人营销",
                            label: "红人营销",
                        },
                        {
                            value: "AMZ AFFILIATE",
                            label: "AMZ AFFILIATE",
                        },
                        {
                            value: "站外Coupon site",
                            label: "站外Coupon site",
                        },
                        {
                            value: "站内LD",
                            label: "站内LD",
                        },
                        {
                            value: "站内BD",
                            label: "站内BD",
                        },
                        {
                            value: "站内7-Day deal",
                            label: "站内7-Day deal",
                        },
                        {
                            value: "站内webstore",
                            label: "站内webstore",
                        },
                        {
                            value: "站内social promotion",
                            label: "站内social promotion",
                        },
                    ],
                    on: {
                        "on-change": (arr) => {
                            this.getBudget();
                        },
                    },
                },
                {
                    label: "活动开始时间",
                    key: "beginTime",
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                    },
                },
                {
                    label: "活动结束时间",
                    key: "endTime",
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                    },
                },
                {
                    label: "促销形式",
                    key: "promotionForm",
                    tag: "vSelect",
                    options: [
                        {
                            value: 1,
                            label: "直降",
                        },
                        {
                            value: 2,
                            label: "折扣号",
                        },
                        {
                            value: 3,
                            label: "买一赠一",
                        },
                        {
                            value: 5,
                            label: "Coupon",
                        },
                        {
                            value: 4,
                            label: "其他",
                        },
                    ],
                },
                {
                    label: "Price",
                    key: "promotionPrice",
                    on: {
                        "on-change": (val) => {
                            this.changePrice(val);
                        },
                    },
                },
                {
                    label: "Final Price",
                    key: "promotionFinalPrice",
                    on: {
                        "on-change": (val) => {
                            this.changeFinalPrice(val);
                        },
                    },
                },
                {
                    label: "产品销售状况",
                    key: "salesSituation",
                    tag: "vSelect",
                    options: [
                        {
                            value: 1,
                            label: "爆款",
                        },
                        {
                            value: 2,
                            label: "滞销款",
                        },
                        {
                            value: 3,
                            label: "新款",
                        },
                        {
                            value: 4,
                            label: "潜力款",
                        },
                        {
                            value: 5,
                            label: "其他",
                        },
                    ],
                },
                {
                    label: "实际折扣:",
                    key: "zheKou",
                    query: true,
                },
                {
                    label: "折扣号",
                    key: "discountNumberUsage",
                },
                {
                    label: "Tracking ID",
                    key: "trackingId",
                },
                {
                    label: "产品链接",
                    key: "productUrl",
                },
                {
                    label: "备注",
                    key: "remark",
                    required: false,
                },
                {
                    label: "发货仓库",
                    key: "shippingWarehouse",
                },
                {
                    label: "活动形式",
                    key: "activityForm",
                    required: false,
                    tag: "vSelect",
                    options: [
                        {
                            value: 1,
                            label: "M001-亚马逊发起的活动",
                        },
                        {
                            value: 2,
                            label: "M002-自发活动",
                        },
                        {
                            value: 3,
                            label: "M003-PM自己降价",
                        },
                        {
                            value: 4,
                            label: "M004-其它平台发起的活动",
                        },
                    ],
                },
                {
                    label: "推广链接",
                    key: "promotionUrl",
                    required: false,
                },
                {
                    label: "推广链接流量",
                    key: "promotionLinkFlow",
                    required: false,
                },
                {
                    label: "单次活动总成本（预算）",
                    key: "budgetPrice",
                    required: false,
                    // promotionType == 1 || promotionType == 2 必填
                    // required: ["站外deal free", "站外deal pay", "站外Facebook Giveaway", "站外FB DEAL GROUP"].includes(this.formData.promotionAccount)
                },
                {
                    label: "单次活动总成本（实际）",
                    key: "promotionCost",
                    required: false,
                },
                {
                    label: "出单成本",
                    key: "promotionRoi",
                    required: false,
                },
                {
                    label: "SP当日流量",
                    key: "spFlow",
                    required: false,
                },
                {
                    label: "SP当日销量",
                    key: "spSale",
                    required: false,
                },
                {
                    label: "实际销售额",
                    key: "sales",
                    required: false,
                },
                {
                    label: "折扣号使用次数",
                    key: "discountNumberCount",
                    required: false,
                },
                {
                    label: "币种:",
                    key: "currencyCode",
                    required: false,
                    query: true,
                },
            ];
        },
    },
    methods: {
        ...mapMutations("diction", ["clearStore"]),
        async getLog() {
            await HttpSysOpLog({
                search: {
                    EQ_opDataId: this.id,
                    EQ_opModel: "PRODUCT_PROMOTION",
                },
            }).then(
                (res) => {
                    this.logList = res.data.content;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async getBudget() {
            if (
                !this.formData.erpSku ||
                !this.formData.accountId ||
                !this.formData.promotionAccount.includes("红人营销")
            )
                return;
            await HttpGetBudgetById({
                erpSku: this.formData.erpSku,
                accountId: this.formData.accountId,
            }).then(
                (res) => {
                    if (!res.data) return;
                    this.formData.budgetPrice = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        changeChannel(value) {
            let objitem;
            objitem = this.getNewAccountIdList.filter(
                (item) => item.value == value
            );
            this.formData.accountFlag = objitem[0].attach.item.flag;
            this.formData.currencyCode = objitem[0].attach.item.currency;
            this.formData.countryCode = objitem[0].attach.item.countryCode;

            this.$emit("on-currency", objitem[0].attach.item.currency);
        },
        changePrice(value) {
            if (
                value != "" &&
                this.formData.promotionFinalPrice != "" &&
                this.formData.promotionFinalPrice != null
            ) {
                var promotionPrice = Number(value);
                var promotionFinalPrice = Number(
                    this.formData.promotionFinalPrice
                );
                var price = Number(
                    (1 - promotionFinalPrice / promotionPrice) * 100
                ).toFixed(2);
                this.$set(this.formData, "zheKou", price + "%");
            }
        },
        changeFinalPrice(value) {
            if (
                value != "" &&
                this.formData.promotionPrice != "" &&
                this.formData.promotionPrice != null
            ) {
                var promotionPrice = Number(this.formData.promotionPrice);
                var promotionFinalPrice = Number(value);
                var price = Number(
                    (1 - promotionFinalPrice / promotionPrice) * 100
                ).toFixed(2);
                this.$set(this.formData, "zheKou", price + "%");
            }
        },
        changeSellerSku(value) {
            if (value != null && value != "") {
                return HttpSellerSku({
                    page: 1,
                    rows: 10,
                    sidx: "id",
                    sord: "desc",
                    search: {
                        EQ_accountFlag: this.formData.accountFlag,
                        EQ_sellerSku: value,
                    },
                }).then((res) => {
                    let objitem;
                    objitem = res.data.content[0];
                    if (objitem != null) {
                        this.$set(this.formData, "erpSku", objitem.erpSku);
                        this.$set(this.formData, "lineId", objitem.lineId);
                        let line;
                        line = this.getNewProductList.filter(
                            (item) => item.value == objitem.lineId
                        );
                        this.$set(this.formData, "lineName", line[0].label);
                    } else {
                        this.$set(this.formData, "erpSku", "");
                        this.$set(this.formData, "lineId", "");
                        this.$set(this.formData, "lineName", "");
                    }
                    this.getBudget();
                });
            }
        },
        update() {
            if (this.type == "add") return;
            if (this.activeids) {
                this.id = this.activeids;
                this.type = this.querytype;
            } else {
                this.id = this.id;
                this.type = this.type;
            }
            HttpGetPromotionOne({
                id: this.id,
            }).then(
                (res) => {
                    let objitem;
                    this.formData = res.data;
                    objitem = this.getNewAccountIdList.filter(
                        (item) => item.value == this.formData.accountId
                    );
                    this.formData.accountFlag = objitem[0].attach.item.flag;
                    this.formData.countryCode =
                        objitem[0].attach.item.countryCode;
                    this.formData.currencyCode =
                        objitem[0].attach.item.currency;
                    var price = Number(
                        (this.formData.promotionFinalPrice /
                            this.formData.promotionPrice) *
                            100
                    ).toFixed(2);
                    this.$set(this.formData, "zheKou", price + "%");
                    if (
                        this.formData.sellerSku != null &&
                        this.formData.sellerSku != ""
                    ) {
                        return HttpSellerSku({
                            page: 1,
                            rows: 10,
                            sidx: "id",
                            sord: "desc",
                            search: {
                                EQ_accountFlag: this.formData.accountFlag,
                                EQ_sellerSku: this.formData.sellerSku,
                            },
                        }).then((res) => {
                            let objitem;
                            objitem = res.data.content[0];
                            if (objitem != null) {
                                this.$set(
                                    this.formData,
                                    "erpSku",
                                    objitem.erpSku
                                );
                                this.$set(
                                    this.formData,
                                    "lineId",
                                    objitem.lineId
                                );
                                let line;
                                line = this.getNewProductList.filter(
                                    (item) => item.value == objitem.lineId
                                );
                                this.$set(
                                    this.formData,
                                    "lineName",
                                    line[0].label
                                );
                            } else {
                                this.$set(this.formData, "erpSku", "");
                                this.$set(this.formData, "lineId", "");
                                this.$set(this.formData, "lineName", "");
                            }
                        });
                    }
                },
                (err) => {}
            );
        },
        async submit(value) {
            let bool3 = await this.$refs.editform.validate();
            if (!bool3) {
                return;
            }
            this.formData.status = value;
            this.formData.promotionAccount =
                this.formData.promotionAccount.join(",");
            this.loading = true;
            HttpSavePromotion({
                ...this.formData,
                orgId: global.SYSID,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        cancel() {
            this.$router.push({
                name: "promotionList",
            });
        },
    },
};
</script>
